import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-secure-blockchain-authoring-tools',
  templateUrl: './secure-blockchain-authoring-tools.component.html',
  styleUrls: ['./secure-blockchain-authoring-tools.component.scss']
})
export class SecureBlockchainAuthoringToolsComponent {
  constructor(private router: Router) {}
  sidebarActive: boolean = true;
}
